"use client";

import { toast } from "sonner";
import styles from "./ShareSection.module.css";

function buildFacebookShareUrl(detailUrl) {
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(detailUrl)}`;
}

function buildTwitterShareUrl(detailUrl, shareText) {
  return `https://twitter.com/intent/tweet?url=${encodeURIComponent(detailUrl)}&text=${encodeURIComponent(shareText || "")}`;
}

export default function ShareSection({ detailUrl, shareText = "", className = "" }) {
  if (!detailUrl) return null;

  const facebookShareUrl = buildFacebookShareUrl(detailUrl);
  const twitterShareUrl = buildTwitterShareUrl(detailUrl, shareText);
  const canNativeShare =
    typeof navigator !== "undefined" && typeof navigator.share === "function";

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(detailUrl);
      toast.success("Холбоос хуулагдлаа!");
    } catch {
      toast.error("Хуулахад алдаа гарлаа");
    }
  };

  const handleNativeShare = async () => {
    try {
      await navigator.share({
        title: shareText || undefined,
        url: detailUrl,
      });
    } catch (error) {
      if (error?.name !== "AbortError") {
        toast.error("Хуваалцахад алдаа гарлаа");
      }
    }
  };

  return (
    <div className={[styles.shareSection, className].filter(Boolean).join(" ")}>
      <span className={styles.shareIcon}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          aria-hidden="true"
        >
          <circle cx="18" cy="5" r="3" />
          <circle cx="6" cy="12" r="3" />
          <circle cx="18" cy="19" r="3" />
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
          <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
        </svg>
      </span>
      <span className={styles.shareLabel}>Хуваалцах</span>
      <div className={styles.shareButtons}>
        <a
          href={facebookShareUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.shareButton}
          aria-label="Facebook дээр хуваалцах"
        >
          Facebook
        </a>
        <a
          href={twitterShareUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.shareButton}
          aria-label="Twitter дээр хуваалцах"
        >
          Twitter
        </a>
        <button
          type="button"
          onClick={handleCopyLink}
          className={styles.shareButton}
          aria-label="Холбоос хуулах"
        >
          Холбоос хуулах
        </button>
        {canNativeShare && (
          <button
            type="button"
            onClick={handleNativeShare}
            className={styles.shareButton}
            aria-label="Хуваалцах"
          >
            Хуваалцах
          </button>
        )}
      </div>
    </div>
  );
}
